(() => {
  console.log('[TEC - DEV]');

  const syncRecommendationsState = (recommendations) => {
    const panel = recommendations.closest('[data-recommendations-panel]');
    const drawer = recommendations.closest('cart-drawer');

    if (!panel || !drawer) {
      return;
    }

    const hasRecommendations = recommendations.innerHTML.trim().length > 0;

    panel.classList.toggle('cart-drawer-recommendations-panel--loaded', hasRecommendations);
    drawer.classList.toggle('cart-drawer--has-recommendations', hasRecommendations);
  };

  const bindRecommendationsPanel = (recommendations) => {
    if (recommendations.dataset.tecRecommendationsBound === 'true') {
      syncRecommendationsState(recommendations);
      return;
    }

    recommendations.dataset.tecRecommendationsBound = 'true';

    const observer = new MutationObserver(() => {
      syncRecommendationsState(recommendations);
    });

    observer.observe(recommendations, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    syncRecommendationsState(recommendations);
  };

  const bindAllRecommendationsPanels = (root = document) => {
    root.querySelectorAll('cart-drawer [data-recommendations-panel] product-recommendations').forEach(bindRecommendationsPanel);
  };

  const cleanEventPayload = (payload) => Object.entries(payload).reduce((cleaned, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }

    return cleaned;
  }, {});

  const publishNexusEvent = (eventName, payload) => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return false;

    try {
      publish.call(window.Shopify.analytics, eventName, cleanEventPayload(payload));
      return true;
    } catch (err) {
      console.warn('TEC analytics event échoué:', err);
      return false;
    }
  };

  const getNewsletterSignupDedupeKey = (email) => [
    'nexus:newsletter_signup',
    (email || '').toLowerCase(),
    window.location.pathname
  ].join('|');

  const publishNewsletterSignupEvent = (container) => {
    if (!container || container.dataset.newsletterSuccess !== 'true') {
      return;
    }

    const email = (container.dataset.newsletterEmail || '').trim();

    if (!email) {
      return;
    }

    const dedupeKey = getNewsletterSignupDedupeKey(email);

    try {
      if (window.sessionStorage?.getItem(dedupeKey) === 'true') {
        return;
      }
    } catch (err) {
      // sessionStorage can be unavailable in restricted browser contexts.
    }

    if (publishNexusEvent('nexus:newsletter_signup', {
      email,
      locale_code: container.dataset.newsletterLocale || window.Shopify?.locale || window.__SHOP_LOCALE__ || 'fr',
      page_path: window.location.pathname,
      source: 'shopify_customer_form'
    })) {
      try {
        window.sessionStorage?.setItem(dedupeKey, 'true');
      } catch (err) {
        // The event has already been published; storage failure should not affect the page.
      }
    }
  };

  const bindNewsletterSignup = (container) => {
    if (container.dataset.tecNewsletterBound === 'true') {
      return;
    }

    container.dataset.tecNewsletterBound = 'true';
    publishNewsletterSignupEvent(container);
  };

  const bindAllNewsletterSignups = (root = document) => {
    root.querySelectorAll('[data-nexus-newsletter-signup]').forEach(bindNewsletterSignup);
  };

  const getBackInStockModal = (alert) => {
    if (!alert.dataset.modalId) {
      return null;
    }

    return document.getElementById(alert.dataset.modalId);
  };

  const getBackInStockProductForm = (alert) => {
    const sectionId = alert.dataset.sectionId;

    if (!sectionId) {
      return null;
    }

    return document.getElementById(`product-form-${sectionId}`);
  };

  const getBackInStockAddButton = (alert) => {
    const holder = alert.closest('.product--product-form');

    if (!holder) {
      return null;
    }

    return holder.querySelector('product-form:not([data-sticky]) .single-add-to-cart-button');
  };

  const setBackInStockMessage = (modal, type, text) => {
    const message = modal && modal.querySelector('[data-back-in-stock-message]');

    if (!message) {
      return;
    }

    message.textContent = text;
    message.classList.remove('back-in-stock-alert__message--success', 'back-in-stock-alert__message--error');
    message.classList.add(`back-in-stock-alert__message--${type}`);
    message.hidden = false;
  };

  const clearBackInStockMessage = (modal) => {
    const message = modal && modal.querySelector('[data-back-in-stock-message]');

    if (!message) {
      return;
    }

    message.textContent = '';
    message.classList.remove('back-in-stock-alert__message--success', 'back-in-stock-alert__message--error');
    message.hidden = true;
  };

  const resetBackInStockModal = (alert, modal) => {
    const form = modal && modal.querySelector('[data-back-in-stock-form]');
    const text = modal && modal.querySelector('[data-back-in-stock-text]');

    if (form) {
      form.classList.remove('back-in-stock-alert__form--success');
      form.reset();
    }

    if (text) {
      if (!text.dataset.initialText) {
        text.dataset.initialText = text.textContent;
      }

      text.textContent = text.dataset.initialText;
    }

    clearBackInStockMessage(modal);
  };

  const setBackInStockSuccess = (modal, text) => {
    const form = modal && modal.querySelector('[data-back-in-stock-form]');
    const textElement = modal && modal.querySelector('[data-back-in-stock-text]');

    if (textElement) {
      if (!textElement.dataset.initialText) {
        textElement.dataset.initialText = textElement.textContent;
      }

      textElement.textContent = text;
    }

    if (form) {
      form.classList.add('back-in-stock-alert__form--success');
    }

    clearBackInStockMessage(modal);
  };

  const publishBackInStockSignupEvent = (alert, email) => {
    publishNexusEvent('nexus:back_in_stock_signup', {
      shopify_product_id: alert.dataset.productId,
      shopify_variant_id: alert.dataset.variantId,
      locale_code: alert.dataset.locale || window.Shopify?.locale || window.__SHOP_LOCALE__ || 'fr',
      email,
      shopify_customer_id: alert.dataset.customerId || null,
      contact_type: alert.dataset.customerId ? 'customer' : 'email',
      product_title: alert.dataset.productTitle || null,
      product_handle: alert.dataset.productHandle || null,
      variant_title: alert.dataset.variantTitle || null
    });
  };

  const syncBackInStockAlert = (alert) => {
    const productForm = getBackInStockProductForm(alert);
    const variantInput = productForm && productForm.querySelector('input[name="id"]');
    const addButton = getBackInStockAddButton(alert);
    const buttonText = addButton && addButton.querySelector('.single-add-to-cart-button--text');
    const unavailableText = (alert.dataset.unavailableText || '').trim();
    const currentText = (buttonText ? buttonText.textContent : '').trim();
    const variantId = variantInput && variantInput.value;
    const isUnavailable = unavailableText && currentText === unavailableText;
    const isSoldOut = Boolean(variantId && addButton && addButton.disabled && !isUnavailable);

    if (variantId) {
      alert.dataset.variantId = variantId;
    }

    alert.hidden = !isSoldOut;
  };

  const syncBackInStockAlerts = (sectionId = null) => {
    document.querySelectorAll('[data-back-in-stock-alert]').forEach((alert) => {
      if (sectionId && alert.dataset.sectionId !== sectionId) {
        return;
      }

      syncBackInStockAlert(alert);
    });
  };

  const bindBackInStockAlert = (alert) => {
    if (alert.dataset.tecBackInStockBound === 'true') {
      syncBackInStockAlert(alert);
      return;
    }

    alert.dataset.tecBackInStockBound = 'true';

    const productForm = getBackInStockProductForm(alert);
    const variantInput = productForm && productForm.querySelector('input[name="id"]');
    const modal = getBackInStockModal(alert);
    const form = modal && modal.querySelector('[data-back-in-stock-form]');
    const opener = alert.querySelector('.back-in-stock-alert__trigger');

    if (variantInput) {
      variantInput.addEventListener('change', () => {
        window.setTimeout(() => syncBackInStockAlert(alert), 0);
      });
    }

    if (opener) {
      opener.addEventListener('click', () => {
        resetBackInStockModal(alert, modal);
        syncBackInStockAlert(alert);
      });
    }

    if (form && modal) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (alert.hidden) {
          return;
        }

        const submitButton = form.querySelector('[type="submit"]');
        const emailInput = form.querySelector('input[name="email"]');
        const email = emailInput ? emailInput.value.trim() : (alert.dataset.customerEmail || '').trim();
        const customerId = (alert.dataset.customerId || '').trim();

        if (!customerId && emailInput && !emailInput.checkValidity()) {
          setBackInStockMessage(modal, 'error', alert.dataset.requiredMessage || alert.dataset.errorMessage);
          emailInput.reportValidity();
          return;
        }

        clearBackInStockMessage(modal);

        const payload = {
          shopify_product_id: alert.dataset.productId,
          shopify_variant_id: alert.dataset.variantId,
          locale_code: alert.dataset.locale || window.Shopify?.locale || 'fr'
        };

        if (customerId) {
          payload.shopify_customer_id = customerId;
        } else {
          payload.email = email;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('loading');
          submitButton.setAttribute('aria-busy', 'true');
        }

        try {
          const response = await fetch('/apps/back-in-stock', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
          });
          const responsePayload = await response.json().catch(() => null);

          if (!response.ok || responsePayload?.status !== 'success') {
            throw new Error('back-in-stock-alert-failed');
          }

          setBackInStockSuccess(modal, alert.dataset.successMessage);
          publishBackInStockSignupEvent(alert, email);
          form.reset();
        } catch (error) {
          setBackInStockMessage(modal, 'error', alert.dataset.errorMessage);
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-busy');
          }
        }
      });
    }

    syncBackInStockAlert(alert);
  };

  const bindAllBackInStockAlerts = (root = document) => {
    root.querySelectorAll('[data-back-in-stock-alert]').forEach(bindBackInStockAlert);
  };

  document.addEventListener('product:variant-change', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    const variantTitle = event.detail && event.detail.variantTitle;

    if (sectionId && variantTitle) {
      document.querySelectorAll(`[data-back-in-stock-alert][data-section-id="${sectionId}"]`).forEach((alert) => {
        alert.dataset.variantTitle = variantTitle;
        alert.querySelectorAll('[data-back-in-stock-variant-title]').forEach((variantTitleElement) => {
          variantTitleElement.textContent = variantTitle;
        });
      });
    }

    window.setTimeout(() => syncBackInStockAlerts(sectionId), 0);
  });

  document.addEventListener('DOMContentLoaded', () => {
    bindAllRecommendationsPanels();
    bindAllNewsletterSignups();
    bindAllBackInStockAlerts();

    const rootObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.matches('cart-drawer [data-recommendations-panel] product-recommendations')) {
            bindRecommendationsPanel(node);
          } else {
            bindAllRecommendationsPanels(node);
          }

          if (node.matches('[data-nexus-newsletter-signup]')) {
            bindNewsletterSignup(node);
          } else {
            bindAllNewsletterSignups(node);
          }

          if (node.matches('[data-back-in-stock-alert]')) {
            bindBackInStockAlert(node);
          } else {
            bindAllBackInStockAlerts(node);
          }
        });
      });
    });

    rootObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
